import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { FEEDBACK_LOCALES } from 'i18n/feedbackLocales';
import { getUserLocale } from 'i18n/getUserLocale';
import { useUserFeedbackQuery } from 'Shared/FeedbackBanner/useUserFeedbackQuery';
import { getFeedbackFormLink } from '../../ChatbotFeedback/utils';
import {
  CloseFeedbackButton,
  CloseFeedbackButtonIcon,
  FeedbackBannerContainer,
  FeedbackBannerText,
  FeedbackBannerTextContainer,
  FeedbackButtonsContainer,
  NovaVoiceIcon,
  ShareFeedbackButtonText,
  ShareFeedbackLink,
} from './styles';

const FEEDBACK_SURVEY_LINK = 'https://unmind.typeform.com/to/Bfmzntxy';

type FeedbackRequestBannerProps = {
  defaultVisibility?: boolean;
};

export function FeedbackRequestBanner({
  defaultVisibility,
}: FeedbackRequestBannerProps) {
  const { t: translate } = useTranslation('chatbot');
  const theme = useTheme();
  const userLocale = getUserLocale();
  const [showBanner, setShowBanner] = useState(defaultVisibility);
  const { data } = useUserFeedbackQuery();
  const feedbackFormLink = getFeedbackFormLink(FEEDBACK_SURVEY_LINK, data);

  if (!showBanner || !FEEDBACK_LOCALES.includes(userLocale)) return null;

  return (
    <FeedbackBannerContainer>
      <FeedbackBannerTextContainer>
        <NovaVoiceIcon
          primaryColor={theme.colors.text.primary}
          width={24}
          height={24}
          aria-hidden="true"
        />
        <FeedbackBannerText
          sizes={[theme.typography.fontSizes.fontSize14]}
          weight={theme.typography.fontWeights.semiBold}
          color={theme.colors.text.primary}
        >
          {translate('voice.feedback.title')}
        </FeedbackBannerText>
      </FeedbackBannerTextContainer>
      <FeedbackButtonsContainer>
        <ShareFeedbackLink
          href={feedbackFormLink}
          target="_blank"
          onClick={() => setShowBanner(false)}
          className="no-external-link-styling"
        >
          <ShareFeedbackButtonText
            sizes={[theme.typography.fontSizes.fontSize12]}
            color={theme.colors.text.inverse}
          >
            {translate('voice.feedback.share_feedback_button.label')}
          </ShareFeedbackButtonText>
        </ShareFeedbackLink>
        <CloseFeedbackButton
          aria-label={translate('voice.feedback.close_button.a11y_label')}
          onClick={() => setShowBanner(false)}
        >
          <CloseFeedbackButtonIcon
            primaryColor={theme.colors.text.primary}
            width={12}
            height={12}
          />
        </CloseFeedbackButton>
      </FeedbackButtonsContainer>
    </FeedbackBannerContainer>
  );
}
